export type VaultQueryState = {
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  isUninitialized: boolean;
  hasData: boolean;
  skip: boolean;
};

export type VaultListStatus = 'loading' | 'error' | 'ready';

/** Error takes precedence over loading so a failed query is never hidden behind a spinner. */
export const getVaultListStatus = (
  queries: readonly VaultQueryState[],
): VaultListStatus => {
  const active = queries.filter((q) => !q.skip);
  if (active.some((q) => q.isError && !q.hasData)) return 'error';
  if (
    active.some(
      (q) => q.isLoading || (q.isFetching && !q.hasData) || q.isUninitialized,
    )
  ) {
    return 'loading';
  }
  return 'ready';
};

/** RTK Query throws when refetching a query that never started. */
export const getQueriesToRetry = <T extends VaultQueryState>(
  queries: readonly T[],
): T[] => queries.filter((q) => !q.skip && q.isError && !q.isUninitialized);
